export const Z_INDEX_PINS = 2600;
export const Z_INDEX_CLUSTERS_MENU = Z_INDEX_PINS + 1;
export const Z_INDEX_CLUSTERS = Z_INDEX_PINS + 2;

export const MAX_CLUSTER_ZOOM = 18;
